import { Injectable } from '@angular/core';
import {  Response } from '@angular/http';
import { Observable }     from 'rxjs/Observable';
import { HttpUtils } from '../../../../../common/http/http-utils';
import GatewayDto  from './dto/gateway-dto';
import { GatewayCliSettingsDto } from './dto/gateway-dto';
import CommonConstants from '../common/common-constants'
import { HttpClient } from '@angular/common/http';

@Injectable()
export class GatewayService {
  public gateways: Array<GatewayDto>;
  private gatewaysLoaded: boolean = false;
  private timer = null;
  private url: string = HttpUtils.getBaseUrl() + '/hybridity/api/gateways';
  private computeUrl: string = HttpUtils.getBaseUrl() + '/hybridity/api/compute';
  private deploymentContainerUrl: string = HttpUtils.getBaseUrl() + '/hybridity/api/compute';
  private globalDeploymentContainerUrl: string = HttpUtils.getBaseUrl() + '/hybridity/api/compute/global/deploymentContainers';
  private singularGatewayUrl: string = HttpUtils.getBaseUrl() + '/hybridity/api/gateways';
  private vcList;
  private nsxEdgeList;
  constructor(public http: HttpClient) {

  }

  getAllGateways() {
    this.gatewaysLoaded = false;
    return this.http.get( this.url )
                    .map( this.extractData ).subscribe(
            (gateways:any) => {
                this.gateways = [].concat(gateways as Array<GatewayDto>);
                this.gatewaysLoaded = true;
            },
            error => this.logError(error, 'get all networks'),
            () => this.logOperationCompleted('get all networks')
        );;
  }

  createGateway(gateway) {
    return this.http.post( this.url, gateway )
                    .map( this.extractData );
  }

  deleteGateway( gatewayId ) {
    let deleteUrl = this.singularGatewayUrl + '/' + gatewayId;
    return this.http.delete( deleteUrl )
                    .map( this.extractData );
  }

  forceSync( gatewayId ) {
    let forceSyncUrl = this.singularGatewayUrl + '/' + gatewayId + "?action=forcesync";
    return this.http.post( forceSyncUrl, gatewayId )
                    .map( this.extractData );
  }

  redeployEdge( gatewayId ) {
    let redployEdgeUrl = this.singularGatewayUrl + '/' + gatewayId + "?action=redeploy";
    return this.http.post( redployEdgeUrl, gatewayId )
                    .map( this.extractData );
  }

  getGateway( gatewayId ) {
    let getUrl = this.singularGatewayUrl + '/' + gatewayId;
    return this.http.get( getUrl )
                    .map( this.extractData );
  }

  updateGateway(gateway) {
    let putUrl = this.singularGatewayUrl + '/' + gateway.objectId;
    return this.http.put(putUrl, gateway)
                    .map(this.extractData);
  }

  getComputeContainer() {
     return this.http.get( this.computeUrl )
                    .map( this.extractData );
  }

  getLocalDeploymentCotainers(scopeId: string) {
    let localDeploymentContainerUrl = this.deploymentContainerUrl + '/' + scopeId + '/deploymentContainers';
    return this.http.get( localDeploymentContainerUrl )
                    .map( this.extractData );
  }

  getGlobalDeploymentContainers() {
    return this.http.get( this.globalDeploymentContainerUrl )
                    .map( this.extractData );
  }

  validateEdgeCliCredentials(scopeId: string, cliSettingsDto: GatewayCliSettingsDto) {
      let validateUrl = this.computeUrl + '/' + scopeId + '?action=validateGatewayCredentials';
      return this.http.post( validateUrl, cliSettingsDto )
                    .map( this.extractData )
  }

    getPermissions(gatewayId){
        let getPermissionsUrl = this.singularGatewayUrl + '/' + gatewayId + '/permissions';
        return this.http.get(getPermissionsUrl)
                    .map(this.extractData);
    }

  private extractData( res: Response ) {
    let body = res;
    return body;
  }

  private logError(error, origin: String = ''): void{
      console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
  }

  private logOperationCompleted(msg: string): void{
      console.log('Operation Completed: ', msg);
  }

  getVcList() {
    return this.http
        .get(HttpUtils.getBaseUrl() + '/hybridity/api/vc/query?entityType=vcenter')
        .map(res => this.vcList = res);
  }

  getNsxEdges(vCenterInstanceUuid: string) {
    return this.http
        .get(HttpUtils.getBaseUrl() + '/admin/hybridity/api/compute/'+ vCenterInstanceUuid + '/nsxEdges')
        .map(res => this.nsxEdgeList = res);
  }

  importGateway(payload) {
    let url = HttpUtils.getBaseUrl() + '/admin/hybridity/api/gateways?action=import'
    return this.http.post(url, payload)
                  .map(this.extractData)
}

}





// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/gateways/gateway.service.ts